module.exports = __webpack_public_path__ + "static/media/logomain.c9edd7b6.png";